import BackgroundImgRemover from './BackgroundImgRemover'

export default BackgroundImgRemover
